import React from "react";
import { BiCheck } from "react-icons/bi";

const servicesData = [
  {
    title: "Technologies",
    items: [
      "Payment gateway: Mercado pago",
      "Login: Auth0, AuthToken, Google",
      "Front-End: Bootstrap, TailwindCSS",
      "Back-End: MongoDB, Mongo Atlas"
    ]
  },
  {
    title: "Soft Skills",
    items: [
      "Attention to detail",
      "Proactive and adaptable",
      "Communication",
      "Team player",
      "Creativity",
      "Planning and Organization"
    ]
  },
  {
    title: "Other",
    items: [
      "English (Intermediate B2)",
      "GitHub",
      "Figma",
      "Postman",
      "Trello",
      "Jira"
    ]
  }
];

const Services = () => {
  return (
    <section id="services" className="py-16 bg-white">
      <h5 className="text-title">What I offer</h5>
      <h2 className="text-subtitle">Services</h2>

      <div className="container mx-auto grid grid-cols-1 md:grid-cols-3 gap-12">
        {servicesData.map((service, index) => (
          <article key={index} className="bg-white shadow-lg rounded-lg overflow-hidden">
            <div className="bg-primary text-white p-4">
              <h3 className="text-center text-xl font-semibold">{service.title}</h3>
            </div>
            <ul className="p-8 space-y-4">
              {service.items.map((item, i) => (
                <li key={i} className="flex items-center">
                  <BiCheck className="text-secondary text-xl" />
                  <p className="ml-2 text-base text-dark">{item}</p>
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </section>
  );
};

export default Services;
